import React from 'react'
import Navbar from '../components/maketApp/site/Navbar'

import Footer from '../components/maketApp/site/Footer'
import OffresRecrutementCards from '../components/maketApp/site/OffresRecrutementCards'
import HerosOffres from '../components/maketApp/site/HerosOffres'

const OffresPAges = () => {
  return (
    <div style={{ background: 'linear-gradient(135deg, #0b1a33, #1a3a6b, #2b7fd4, #4a90e2)'}}>
       <Navbar />
       <HerosOffres />
       <OffresRecrutementCards />
     
         <Footer />
    </div>
  )
}

export default OffresPAges
